import { render, staticRenderFns } from "./colForm.vue?vue&type=template&id=bed23666&scoped=true&"
import script from "./colForm.vue?vue&type=script&lang=js&"
export * from "./colForm.vue?vue&type=script&lang=js&"
import style0 from "./colForm.vue?vue&type=style&index=0&id=bed23666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed23666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bed23666')) {
      api.createRecord('bed23666', component.options)
    } else {
      api.reload('bed23666', component.options)
    }
    module.hot.accept("./colForm.vue?vue&type=template&id=bed23666&scoped=true&", function () {
      api.rerender('bed23666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/components/colForm.vue"
export default component.exports